import type { DirectiveBinding } from "vue";
import { useSanitize } from "@common/composable/useSanitize";

const { sanitizeUrl, sanitizeStyle, sanitizeClass } = useSanitize();

export const vSafeHref = {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    el.setAttribute("href", sanitizeUrl(binding.value));
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    el.setAttribute("href", sanitizeUrl(binding.value));
  }
};

export const vSafeSrc = {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    el.setAttribute("src", sanitizeUrl(binding.value));
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    el.setAttribute("src", sanitizeUrl(binding.value));
  }
};

export const vSafeAction = {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    el.setAttribute("action", sanitizeUrl(binding.value));
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    el.setAttribute("action", sanitizeUrl(binding.value));
  }
};

export const vSafeStyle = {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    applySafeStyle(el, binding.value);
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    applySafeStyle(el, binding.value);
  }
};

function applySafeStyle(el: HTMLElement, value: any) {
  const sanitized = sanitizeStyle(value);
  if (typeof sanitized === "object") {
    Object.assign(el.style, sanitized);
  } else {
    el.setAttribute("style", sanitized);
  }
}

export const vSafeClass = {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    el.dataset._baseClass = el.className;
    applySafeClass(el, binding.value);
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    applySafeClass(el, binding.value);
  }
};

function applySafeClass(el: HTMLElement, value: any) {
  const sanitized = sanitizeClass(value);
  const baseClasses = (el.dataset._baseClass || "").split(/\s+/).filter(Boolean);

  let safeClasses: string[] = [];

  if (typeof sanitized === "string") {
    safeClasses = sanitized.split(/\s+/);
  } else if (Array.isArray(sanitized)) {
    safeClasses = sanitized;
  } else if (typeof sanitized === "object") {
    safeClasses = Object.keys(sanitized).filter((cls) => sanitized[cls]);
  }

  const merged = [...new Set([...baseClasses, ...safeClasses])].join(" ");
  el.className = merged;
}
